import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=4b60f017&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=4b60f017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60f017",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b60f017')) {
      api.createRecord('4b60f017', component.options)
    } else {
      api.reload('4b60f017', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=4b60f017&scoped=true&", function () {
      api.rerender('4b60f017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/winner/Detail.vue"
export default component.exports